import { createContext, useContext } from "react";

export const ModalPedidoContext = createContext(null);

export const ModalPedidoProvider = ModalPedidoContext.Provider;

export const useModalPedido = () => {
  const context = useContext(ModalPedidoContext);

  if (!context) {
    throw new Error("useModalPedido debe usarse dentro de ModalPedidoProvider");
  }

  return context;
};
